<template>
  <div class="headerbox">
    <img src="../assets/img/logo.png" alt="" />
    <div class="center">
      <el-menu :default-active="activeIndex" router mode="horizontal" class="el-menu-demo" active-text-color="#19CBBE">
        <el-menu-item index="/">{{ $t("lg.店铺") }}</el-menu-item>
        <el-menu-item index="goods">{{ $t("lg.商品匹配") }}</el-menu-item>
        <el-menu-item index="pageList">{{ $t("lg.订单同步") }}</el-menu-item>
        <el-menu-item index="logList">{{ $t("lg.操作日志") }}</el-menu-item>
        <el-submenu index="setting">
          <template slot="title">{{ $t("lg.设置") }}</template>
          <el-menu-item index="shopsetting">{{ $t("lg.参数设置") }}</el-menu-item>
          <el-menu-item index="carrier">{{ $t("lg.物流管理") }}</el-menu-item>
          <el-menu-item index="order_attribute">{{ $t("lg.订单字段映射") }}</el-menu-item>
          <el-menu-item index="user">{{ $t("lg.用户") }}</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="right">
      <img src="../assets/img/ying@2x.png" alt="" v-if="oms_lang == 'zh'" @click="languageSwitching" />
      <img src="../assets/img/wen@2x.png" alt="" v-else @click="languageSwitching" />
      <!-- v-if="options.length" -->
      <el-select v-if="options.length" v-model="api_id" size="small" :placeholder="$t('lg.请选择')" filterable
        style="max-width:160px;" remote @change="change">
        <div class="selebtn">
          <el-button type="text" @click.native.prevent="apishow = true">{{ $t('lg.绑定') }}DEAR</el-button>
        </div>
        <el-option v-for="item in options" :key="item.id" :label="item.company" :value="item.id">
        </el-option>
      </el-select>
      <!-- v-else -->
      <div class="new_selebtn " v-else @click="apishow = true">
        {{ $t('lg.绑定') }}DEAR
        <!-- <el-button type="text" @click.native.prevent="apishow = true">{{ $t('lg.绑定') }}DEAR</el-button> -->
      </div>
      <el-dropdown class="logobox" trigger="click">
        <div class="logo">
          <div class="imgsbox">
            <img src="../assets/img/smile.svg" class="user-avatar">
          </div>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="apidel">
            <el-dropdown-item>{{ $t('lg.我的订阅') }}</el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="sendshow = true">
            <span>{{ $t('lg.修改密码') }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :title="$t('lg.修改密码')" :visible.sync="sendshow" width="30%">
      <el-form ref="sendform" :model="sendform" :rules="sendrules" class="formbox">
        <el-form-item prop="email">
          <span class="form_tit">{{ $t("lg.邮件地址") }}*</span>
          <el-input v-model="sendform.email" clearable></el-input>
        </el-form-item>
        <el-form-item class="btnbox">
          <el-button type="primary" @click.native.prevent="sendPasswordEmail" :loading="loadinga">{{ $t("lg.发送")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="`${$t('lg.绑定')}DEAR`" :visible.sync="apishow" width="30%">
      <el-form ref="form" :model="form" :rules="rules" class="formbox">
        <el-form-item prop="api_account">
          <span class="form_tit">API Account*</span>
          <el-input v-model="form.api_account" clearable></el-input>
        </el-form-item>
        <el-form-item prop="api_key">
          <span class="form_tit">API Key*</span>
          <el-input v-model="form.api_key" clearable></el-input>
        </el-form-item>
        <el-form-item class="btnbox">
          <el-button type="primary" @click.native.prevent="onSubmit" :loading='btn_loading'>{{ $t('lg.保存')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import { removeToken } from '@/utils/auth'
  import BUS from '@/utils/bus.js'
  export default {
    components: {},
    data() {
      return {
        activeIndex: "/",
        api: "",
        oms_lang: "" || "zh",
        options: [],
        // 修改密码
        sendshow: false,
        sendform: {
          email: "",
        },
        sendrules: {
          email: [
            {
              required: true,
              trigger: "blur",
              message: this.$t("lg.请输入邮件地址"),
            },
          ],
        },
        loadinga: false,
        // 添加
        apishow: false,
        btn_loading: false,
        form: {
          api_account: '',
          api_key: '',
        },
        rules: {
          api_account: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
          api_key: [
            { required: true, trigger: "blur", message: this.$t('lg.请输入') }
          ],
        },
      };
    },
    computed: {
      api_id: {
        get() {
          return this.$store.state.user.api_id;
        },
        set(data) {
          this.$store.dispatch("change_API_ID", data);
        },
      },
    },
    watch: {
      api_id: {
        handler(data) {
          if (data) {
            this.getinfo(data)
          }
        },
        deep: true,
        immediate: true
      },
      $route: {
        handler(data) {
          sessionStorage.setItem("activeIndex", data.name);
          this.activeIndex = data.name;
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      getlist() {
        this.$post({
          url: "/app/member_api/apiList",
          data: {
            page: 1,
            page_size: 1000,
          },
          success: (res) => {
            this.options = res.data.data;
            if (this.options.length && !this.api_id) {
              this.api_id = this.options[0].id;
              this.$store.dispatch("change_API_ID", this.api_id);
            }
          },
          tip: () => { },
        });
      },
      getinfo(api_id) {
        this.$post({
          url: "/app/member/getRules",
          data: { api_id },
          success: (res) => {
            this.$store.dispatch("set_ROLES", res.data.rule_names);
          },
          tip: () => { },
        });
      },
      languageSwitching() {
        let lang = "";
        if (this.oms_lang == "en") {
          this.oms_lang = "zh";
          lang = "cn";
          this.$i18n.locale = "zh";
          localStorage.setItem("oms_lang", "zh");
        } else {
          this.oms_lang = "en";
          lang = "en";
          this.$i18n.locale = "en";
          localStorage.setItem("oms_lang", "en");
        }
        this.$message({
          message: this.$t("lg.切换语言成功"),
          type: "success",
        });
      },
      change() {
        const { name } = this.$route
        sessionStorage.removeItem("goods_activeName")
        sessionStorage.removeItem("orderList_activeName")
        sessionStorage.removeItem('carrier_activeName')
        sessionStorage.removeItem('order_attribute_activeName')
        sessionStorage.removeItem('shopsetting_activeName')
        sessionStorage.removeItem('user_activeName')
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect',
            query: {
              redirect: name
            }
          })
        })
      },
      sendPasswordEmail() {
        this.$refs.sendform.validate((valid) => {
          if (valid) {
            this.loadinga = true;
            this.$post({
              url: "/app/auth/sendPasswordEmail",
              data: this.sendform,
              success: () => {
                this.$message({
                  message: "发送成功",
                  type: "success",
                });
                setTimeout(() => {
                  this.show = false;
                  this.loadinga = false;
                }, 1500);
              },
              tip: () => {
                setTimeout(() => {
                  this.loadinga = false;
                }, 1500);
              },
            });
          }
        });
      },
      // 退出登录
      logout() {
        this.$confirm(`${this.$t('lg.确定要退出登录')}?`, this.$t('lg.提示'), {
          confirmButtonText: this.$t('lg.确定'),
          cancelButtonText: this.$t('lg.取消'),
          type: 'warning'
        }).then(() => {
          this.$post({
            url: "/app/member/logout",
            success: (res) => {
              removeToken()
              sessionStorage.removeItem("goods_activeName")
              sessionStorage.removeItem("orderList_activeName")
              sessionStorage.removeItem('carrier_activeName')
              sessionStorage.removeItem('order_attribute_activeName')
              sessionStorage.removeItem('shopsetting_activeName')
              sessionStorage.removeItem('vuex')
              this.$router.replace('login')
              this.$message({
                type: 'success',
                message: this.$t('lg.退出登录')
              });
            },
            tip: () => {
            },
          })
        }).catch(() => {
        });
      },
      // 添加
      onSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.btn_loading = true
            this.$post({
              url: "/app/member_api/bindApi",
              data: this.form,
              success: (res) => {
                this.$message({
                  message: this.$t('lg.成功'),
                  type: 'success'
                });
                this.apishow = false
                setTimeout(() => {
                  this.getlist
                  this.btn_loading = false
                }, 1000);
              },
              tip: () => {
                setTimeout(() => {
                  this.btn_loading = false
                }, 1500);
              },
            })
          }
        });
      },
    },
    created() {
      this.getlist();
      if (localStorage.getItem("oms_lang")) {
        this.oms_lang = localStorage.getItem("oms_lang");
      }
      BUS.$on('apilist', () => {
        this.getlist();
      })
    },
  };
</script>
<style lang="scss" scoped>
  .headerbox {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow-x: auto;
    >img {
      width: 100px;
      height: 40px;
    }
    .center {
      flex: 1;
      padding: 0 30px;
      .el-menu-demo {
        width: 100%;
      }
    }
    .right {
      width: 22%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      >img {
        width: 25px;
        height: 25px;
        margin-right: 20px;
      }
      .logobox {
        margin-left: 20px;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .logo {
          display: flex;
          cursor: pointer;
          .imgsbox {
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #000;
            border-radius: 50%;
            margin-right: 3px;
          }
          /deep/.el-icon-caret-bottom {
            display: flex;
            align-items: flex-end;
            padding-bottom: 10px;
          }
        }
      }
    }
    .formbox {
      width: 480px;
      padding: 10px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .imgbox {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 147px;
          height: 53px;
        }
        p {
          width: 100%;
          text-align: center;
          color: #3b3b3b;
          font-size: 40px;
          font-weight: 600;
          font-family: PingFang SC;
          padding: 40px 0;
        }
      }
      .password {
        width: 100%;
        p {
          color: $color;
          font-size: 16px;
          cursor: pointer;
        }
        margin-bottom: 40px;
      }
      /deep/.el-form-item {
        width: 100%;
        margin-bottom: 30px !important;
        .el-input {
          .el-input__inner {
            height: 50px;
          }
        }
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color !important;
            border-radius: 5px;
            border-color: $color;
            font-size: 16px;
            font-weight: 600;
          }
        }
      }
      .registerbox {
        width: 100%;
        text-align: center;
        color: #3b3b3b;
        font-size: 16px;
        padding-top: 10px;
        a {
          color: $color;
          font-size: 16px;
        }
      }
    }
  }
  .selebtn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .new_selebtn {
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    font-size: 12px;
    color: #c2c7ce;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
  }
</style>
